import { datepicker } from "../../../../../../js/san_jacinto_2022/mobiscroll.javascript.min.js";
const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const calendarNav = $(".page-list-calendar .calendar-nav-bar");

if (calendarNav) {
  const currentDateField = $("#calendar-date-input");
  const dayDisplay = $(".selected-day", calendarNav);
  const prevButton = $(".prev-day", calendarNav);
  const nextButton = $(".next-day", calendarNav);
  const calendarEventList = $(".calendar-event-list");
  const events = $$("article", calendarEventList);
  const eventMap = new Map();
  const today = new Date();
  const minDate = new Date();
  const maxDate = new Date();
  const sam = $("body").classList.contains("samadmin") && window.location.origin.indexOf("localhost") === -1;
  minDate.setFullYear(minDate.getFullYear() - 1);
  maxDate.setFullYear(maxDate.getFullYear() + 1);
  const serverEvents = {};
  const serverHours = {};

  // const calendar = jQuery( "#datepicker" ).datepicker({
  //   altField: "#calendar-date-input",
  //   onSelect: function() {
  //     if ("createEvent" in document) {
  //       var evt = document.createEvent("HTMLEvents");
  //       evt.initEvent("change", false, true);
  //       currentDateField.dispatchEvent(evt);
  //     }
  //     else {
  //       currentDateField.fireEvent("onchange");
  //     }
  //   }
  // });

  const calendar = datepicker('#calendar-date-input', {
    controls: ['calendar'],
    display: 'inline',
    inputTyping: true,
    theme: "material",
    themeVariant: "light",
    min: minDate,
    max: maxDate
  });

  events.forEach(function(event) {
    const title = event.dataset.title.toLowerCase();
    eventMap.set(title, event);
  });

  function updateDate(date) {
    //jQuery("#datepicker").datepicker("setDate", date.toLocaleDateString());
    calendar.setVal(date.toLocaleDateString());
    currentDateField.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function nextDay() {
    const tomorrow = new Date(currentDateField.value);
    tomorrow.setDate(tomorrow.getDate() + 1);
    updateDate(tomorrow);
  }

  function prevDay() {
    const tomorrow = new Date(currentDateField.value);
    tomorrow.setDate(tomorrow.getDate() - 1);
    updateDate(tomorrow);
  }

  function clearEvents() {
    eventMap.forEach((event, key) => {
      event.classList.add("hidden");
      const eventTimes = $(".times", event);
      eventTimes.innerHTML = "";
    });
  }

  function filterEvents(events, hours) {
    clearEvents();

    events.forEach(function(event) {
      const title = event.title.toLowerCase();
      const matchedEvent = eventMap.get(title);

      if (matchedEvent) {
        const eventTimes = $(".times", matchedEvent);
        const eventLink = $("a", matchedEvent);
        let datestring = `date=${encodeURIComponent(currentDateField.value)}`;
        if(sam ) {
          const eventLinkHREF = eventLink.getAttribute("href").split("&")[0];
          eventLink.setAttribute("href", eventLinkHREF + `&${datestring}`);
        } else {
          const eventLinkHREF = eventLink.getAttribute("href").split("?")[0];
          eventLink.setAttribute("href", eventLinkHREF + `?${datestring}`);
        }

        if (!event["all-day"]) {
          const startDate = new Date(event.start);
          const endDate = new Date(event.end);
          const newTime = document.createElement('li');
          let formattedStart = startDate.toLocaleTimeString("en-US",{timezone: "America/Chicago"}).replaceAll(":00", "").replaceAll(" ","").replaceAll("AM", " a.m.").replaceAll("PM", " p.m.");
          let formattedEnd = endDate.toLocaleTimeString("en-US",{timezone: "America/Chicago"}).replaceAll(":00", "").replaceAll(" ","").replaceAll("AM", " a.m.").replaceAll("PM", " p.m.");
          newTime.textContent = `${formattedStart} - ${formattedEnd}`;
          eventTimes.append(newTime);
        } else {
          let formattedHours = "";
          const newTime = document.createElement('li');

          if (hours.error && hours.error.toLowerCase() === "closed") {
            formattedHours = hours.error;
          } else if (hours.error && hours.error.toLowerCase() === "times not defined") {
            const hoursElement = $("#scroll-anchor");
            const open = hoursElement.dataset.open;
            const close = hoursElement.dataset.close;
            formattedHours = `${open} - ${close}`;
          } else {
            const start = hours.start;
            const end = hours.end;
            let formattedStart = start.replaceAll(":00", "").replaceAll(" ","").replaceAll("AM", " a.m.").replaceAll("PM", " p.m.");
            let formattedEnd = end.replaceAll(":00", "").replaceAll(" ","").replaceAll("AM", " a.m.").replaceAll("PM", " p.m.");
            formattedHours = `${formattedStart} - ${formattedEnd}`;
          }

          newTime.textContent = formattedHours;
          eventTimes.append(newTime);
        }
        matchedEvent.classList.remove("hidden");
      }
    });
  }

  async function queryServerEvents() {
    const currentDate = new Date(currentDateField.value);
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const day = currentDate.getDate();
    const key = `${year}-${month}`;
    const hoursKey = `${year}-${month}-${day}`;

    if (!serverEvents[key]) {
      let response = await fetch(`/proxy/events?year=${year}&month=${month}`);
      let events = await response.json();
      serverEvents[key] = events;
    }

    if (!serverHours[hoursKey]) {
      let response = await fetch(`/proxy/hours?year=${year}&month=${month}&day=${day}`);
      let hours = await response.json();
      serverHours[hoursKey] = hours;
    }

    const hours = serverHours[hoursKey];

    const dayEvents = serverEvents[key].filter(function(event) {
      const startDate = new Date(event.start);
      const endDate = new Date(event.end);
      const currentDateString = currentDate.toLocaleDateString("en-US");
      const startDateString = startDate.toLocaleDateString("en-US");

      if (event["all-day"]) {
        return currentDate.getTime() >= startDate.getTime() && currentDate.getTime() <= endDate.getTime(); 
      }

      return currentDateString === startDateString;
    })

    filterEvents(dayEvents, hours);
  }

  currentDateField.addEventListener("change", function(e) {
    if (e.target.value !== "") {
      const today = new Date();
      today.setHours(0,0,0,0);
      const date = new Date(e.target.value);
      date.setHours(0,0,0,0);
      const month = date.getMonth();
      const day = date.getDate();
      const year = date.getFullYear();
      const friendlyMonth = date.toLocaleString('default', { month: 'long' });
      let todayDisplay = "";
      if (today.getTime() === date.getTime()) {
        todayDisplay = "Today: ";
      }
      const friendlyDate = `${todayDisplay}${friendlyMonth} ${day}, ${year}`;
      dayDisplay.textContent = friendlyDate;
      queryServerEvents();
    }
  });

  nextButton.addEventListener("click", function(e){
    nextDay();
  });

  prevButton.addEventListener("click", function(e){
    prevDay();
  });

  updateDate(today);
}